import { SxProps, Theme } from '@mui/material/styles'

export const inputPaperVariant: SxProps<Theme> = {
    /* Standard MUI inputs */
    '& .MuiOutlinedInput-root, & .MuiInputBase-root': {
        backgroundColor: 'background.paper',
    },

    /* MUI X Pickers */
    '& .MuiPickersInputBase-root, & .MuiPickersOutlinedInput-root': {
        backgroundColor: 'background.paper',
    },

    /* Actual <input> element (important for autofill & inner transparency) */
    '& .MuiOutlinedInput-input, & .MuiInputBase-input, & .MuiPickersInputBase-input':
        {
            backgroundColor: 'transparent',
        },
}
